<template>
  <div class="container">
    <div style="display: flex;align-items: center;margin-top: 20px;">
      <div>业务员：</div>
      <vxe-pulldown ref="sellerDown" transfer class="pulldown" style="width: 200px;margin-left: 10px;">
        <template>
          <a :title="salesManName" class="link-text" @click="focusEvent" target="_black"
             style="cursor: pointer;display: inline-block;width: 100%;text-align: left;"
          >{{salesManName === null || salesManName === "" ? placeholder : salesManName }}</a
          >
        </template>
        <template v-slot:dropdown>
          <div class="chainId-dropdown">
            <Input
                search
                suffix="ios-search"
                v-model="userName"
                @on-search="search"
                style="width: 200px"
            />
            <vxe-grid
                border="none"
                highlight-hover-row
                auto-resize
                height="auto"
                :loading="loading"
                :pager-config="tablePage"
                :data="tableList"
                :columns="tableColumn"
                @cell-click="cellClickEvent"
                @page-change="pageChange"
            ></vxe-grid>
          </div>
        </template>
      </vxe-pulldown>
    </div>
    <div class="add-btn-box" style="margin-top: auto;">
      <Button style="border-radius: 5px;" @click="close">取消</Button>
      <Button type="primary" style="border-radius: 5px;" @click="commit">确定</Button>
    </div>
  </div>
</template>
<script>

  import {isEmpty, isNotEmpty} from "@/utils/util";
  import $api from "@/apiProvider";

  export default {
    props: {
      placeholder: {
        type: String,
        default: "选择业务员",
      },
    },
    data() {
      return {
        salesMan: null,
        salesManName: null,
        tableList: [],
        loading: false,
        userName: "",
        tableColumn: [{field: "name", title: "姓名"}], // 表格数据列
        tablePage: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          size: "mini",
        },
      }
    },
    methods: {
      init() {
        this.salesMan = null;
        this.salesManName = null;
        this.userName = null;
      },
      commit() {
        if (isEmpty(this.salesMan)) {
          this.$XModal.alert({
            message: '请选择业务员',
            status: "error",
          });
          return
        }
        this.$emit('batchAdd', this.salesMan);
      },
      close() {
        this.$emit('close');
      },
      focusEvent() {
        this.tablePage.currentPage = 1;
        this.userName = "";
        this.getUserList();
        this.$refs.sellerDown.showPanel();
      },
      search() {
        this.tablePage.currentPage = 1;
        this.getUserList();
      },
      cellClickEvent({row}) {
        this.salesManName = row.name;
        this.salesMan = row;
        if (isNotEmpty(this.$refs.sellerDown)) {
          this.$refs.sellerDown.hidePanel();
        }
      },
      pageChange(e) {
        this.tablePage.currentPage = e.currentPage;
        this.tablePage.pageSize = e.pageSize;
        this.getUserList();
      },
      async getUserList() {
        let params = {
          orderBy: 2,
          page: this.tablePage.currentPage,
          rows: this.tablePage.pageSize,
        };

        if (isNotEmpty(this.userName)) {
          params.userName = this.userName;
        }
        if (isEmpty(this.tableList)) {
          this.loading = true;
        }

        let res = await $api.user.request("querySaleManagerList", params);
        this.loading = false;
        if (res.status === 1) {
          this.tablePage.total = res.data.total;
          this.tableList = res.data.rows;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
    }
  }
</script>
<style lang="css">
  .chainId-dropdown {
    width: 400px;
    height: 300px;
    background-color: #fff;
    border: 1px solid #dcdfe6;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.16);
    position: relative;
  }

  .chainId-dropdown .ivu-input-wrapper {
    position: absolute;
    right: 10px;
    top: 8px;
    z-index: 999;
  }

  .chainId-dropdown .ivu-input {
    border-radius: 0;
  }

  .pulldown .vxe-pulldown--content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
  }
</style>